export enum AccountType {
  Personal = 'personal',
  Organisation = 'organisation',
}
